// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"second-content_wrapper__37A6H","redText":"second-content_redText__WlJCK","boldText":"second-content_boldText__13Vhs"};